module.exports = ".btn-feedback {\r\n\tbackground-color:#104e65;\r\n\tcolor: white;\r\n\tborder-color: #104e65;\r\n\tborder-radius: 4px;\r\n}"